import styled from "styled-components";

export const ContentContainer = styled.div({
    display: "flex",
    flexDirection: "column",
});

export const PNRInputFieldContainer = styled.div(({ theme }) => ({
    marginTop: theme.spacing.large,
    marginBottom: theme.spacing.medium,
}));

export const TextWrapper = styled.div(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.xxxSmall,
    marginTop: theme.spacing.xxSmall,
}));
